import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { trackAboutFlatAndHomeShow } from 'shared/containers/OfferSummaryInfoNew/tracking/tracking';

import { CardSectionNew } from '../../components/CardSectionNew';
import { OfferSummaryInfoLayout } from '../../components/OfferSummaryInfo';
import { FeaturesContainerNew } from '../FeaturesNew';
import {
  OfferSummaryInfoBuilding,
  OfferSummaryInfoBusinessCenter,
  OfferSummaryInfoCommercial,
  OfferSummaryInfoCommunication,
  OfferSummaryInfoSuburban,
  OfferSummaryInfoUrban,
} from './parts';

export const OfferSummaryInfoNew: React.FC = () => {
  return (
    <ActionAfterViewed callback={trackAboutFlatAndHomeShow}>
      <CardSectionNew>
        <OfferSummaryInfoLayout>
          <OfferSummaryInfoUrban />
          <OfferSummaryInfoBuilding />
          <OfferSummaryInfoSuburban />
          <OfferSummaryInfoCommercial />
        </OfferSummaryInfoLayout>

        <OfferSummaryInfoLayout>
          <OfferSummaryInfoCommunication />
        </OfferSummaryInfoLayout>

        <FeaturesContainerNew />

        <OfferSummaryInfoLayout>
          <OfferSummaryInfoBusinessCenter />
        </OfferSummaryInfoLayout>
      </CardSectionNew>
    </ActionAfterViewed>
  );
};
